module.exports = __webpack_public_path__ + "static2023-4-17/img/guide-recent.abd3d8a2.png";